import { render, staticRenderFns } from "./LicenceReminder.vue?vue&type=template&id=6180e11e&"
import script from "./LicenceReminder.vue?vue&type=script&lang=js&"
export * from "./LicenceReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports